import { call, put } from 'redux-saga/effects';
import { BACKEND_URL, FRONT_URL } from '../../../configs';
import { getESIAUrlFailed } from '../actions';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';

export default function* getESIAUrl(action) {
  try {
    const { payload = {} } = action;
    const url = `${BACKEND_URL}/auth/trust-gate/get-redirect-url`;
    const dataResponse = yield makeRequest(url, {
      redirect_url: `${payload?.inviteLink || FRONT_URL}/esia-callback`,
    }, action, 'GET', true);
    const data = yield getBodyJson(dataResponse);
    if (dataResponse?.status === OK && data) {
      window.location.href = data.url;
    } else {
      yield put(getESIAUrlFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(getESIAUrlFailed(e));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
